import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowUpRight, Check, Upload } from "lucide-react";
import { API } from "@/App";
import { BRAND, INTEREST_OPTIONS, waLink } from "@/data/content";

export default function LeadForm({ preset = [], title = "Get a Free Consultation" }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", interests: preset, preferred_contact: "whatsapp", message: "", consent: false });
  const [files, setFiles] = useState([]);
  const [state, setState] = useState("idle");

  const toggleInterest = (item) => {
    setForm((f) => ({ ...f, interests: f.interests.includes(item) ? f.interests.filter((i) => i !== item) : [...f.interests, item] }));
  };

  const submit = async (event) => {
    event.preventDefault();
    if (form.interests.length === 0) { toast.error("Kripya kam se kam ek service chunein."); return; }
    setState("sending");
    try {
      const { data: lead } = await axios.post(`${API}/leads`, {
        name: form.name, phone: form.phone, email: form.email, interests: form.interests,
        service: form.interests[0], preferred_contact: form.preferred_contact,
        message: form.message, consent: form.consent,
      });
      for (const file of files) {
        const body = new FormData();
        body.append("file", file);
        await axios.post(`${API}/leads/${lead.id}/documents`, body);
      }
      setState("sent");
      toast.success("Enquiry received! Hum jald contact karenge.");
      const text = `Hello Bima Bachat Bazar 👋\n\nMy name is ${form.name}.\n\nI would like assistance regarding:\n${form.interests.map((i) => `• ${i}`).join("\n")}\n\n${form.message ? `Note: ${form.message}\n` : ""}Please contact me regarding my requirement.\nThank you.`;
      window.open(waLink(text), "_blank", "noopener,noreferrer");
      setForm({ name: "", phone: "", email: "", interests: preset, preferred_contact: "whatsapp", message: "", consent: false });
      setFiles([]);
    } catch {
      setState("error");
      toast.error("Enquiry save nahi ho payi. Kripya call karein.");
    }
  };

  return (
    <form className="lead-form" onSubmit={submit} data-testid="lead-enquiry-form">
      <div className="form-kicker">{title} <span>•</span> Let us understand your requirement</div>
      <div className="form-row">
        <label>Name*<input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Enter Your Name" data-testid="lead-name-input" /></label>
        <label>Mobile Number*<input required pattern="[0-9]{10}" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })} placeholder="Enter 10 Digit Mobile Number" data-testid="lead-phone-input" /></label>
      </div>
      <label>Email<input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Enter Email Address" data-testid="lead-email-input" /></label>
      <div className="form-label">I am interested in:</div>
      <div className="interest-grid" data-testid="interest-checkbox-grid">
        {INTEREST_OPTIONS.map((item) => (
          <button type="button" key={item} onClick={() => toggleInterest(item)} className={form.interests.includes(item) ? "interest-chip active" : "interest-chip"} data-testid={`interest-${item.toLowerCase().replaceAll(/[^a-z0-9]+/g, "-")}`}>
            {form.interests.includes(item) && <Check size={13} />} {item}
          </button>
        ))}
      </div>
      <div className="form-label">Preferred Contact Method:</div>
      <div className="radio-row" data-testid="preferred-contact-group">
        {[["call", "Call"], ["whatsapp", "WhatsApp"]].map(([value, label]) => (
          <label key={value} className={form.preferred_contact === value ? "radio-pill active" : "radio-pill"}>
            <input type="radio" name="preferred_contact" checked={form.preferred_contact === value} onChange={() => setForm({ ...form, preferred_contact: value })} data-testid={`contact-method-${value}`} /> {label}
          </label>
        ))}
      </div>
      <label>Your Requirement<textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Write your requirement" data-testid="lead-message-input" /></label>
      <label className="file-drop" data-testid="lead-file-upload">
        <Upload size={16} />
        <span>{files.length ? files.map((f) => f.name).join(", ") : "Attach documents (optional) — JPG, PNG, PDF up to 10MB"}</span>
        <input type="file" multiple accept=".jpg,.jpeg,.png,.webp,.pdf" onChange={(e) => setFiles(Array.from(e.target.files || []).slice(0, 3))} data-testid="lead-file-input" />
      </label>
      <label className="consent">
        <input type="checkbox" required checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} data-testid="lead-consent-checkbox" />
        <span>Your information will be used only for responding to your enquiry and providing relevant assistance, subject to our Privacy Policy.</span>
      </label>
      <button className="btn btn-primary submit-btn" disabled={state === "sending"} data-testid="lead-submit-button">
        {state === "sending" ? "Sending…" : "Submit Enquiry"} <ArrowUpRight size={16} />
      </button>
      {state === "sent" && <div className="form-success" data-testid="lead-success-message"><Check size={15} /> Thanks! Your enquiry is saved and WhatsApp message is ready.</div>}
      {state === "error" && <div className="form-error" data-testid="lead-error-message">Could not save. Please call {BRAND.phone1} directly.</div>}
    </form>
  );
}
